/**
* Before and After Carousel JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Carousel component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-carousel',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.before-and-after-carousel-splide' ).length ) {
        $( '.before-and-after-carousel-splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            perMove: 1,
            autoWidth: true,
            gap: '1rem',
            arrows: false,
            pagination: false,
          } );

          const bar = splide.root.querySelector( '.progress-bar' );

          splide.on( 'mounted move', function() {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min( ( splide.index + 1 ) / end, 1 );
            bar.style.width = String( 100 * rate ) + '%';
          } );

          const prev = splide.root.querySelector( '.before-and-after-carousel-prev' );
          const next = splide.root.querySelector( '.before-and-after-carousel-next' );

          prev.addEventListener( 'click', () => splide.go( '<' ) );
          next.addEventListener( 'click', () => splide.go( '>' ) );

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-carousel', COMPONENT );
} )( app );
